/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, ListItem, makeStyles, mergeClasses, Text, TextProps, Tooltip } from "@fluentui/react-components";
import { Phone } from "../../data/types";
import { useUtilities } from "../../utilities/useUtilities";
import { useCommonStyles } from "../common/Styles/commonStyles";
import { Column, Row } from "../common";
import { Dismiss16Regular, StarFilled, StarRegular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    item: {
        '& .hidden': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& .hidden': {
                visibility: 'visible'
            }
        }
    }
});

export type PhoneControlProps = Partial<TextProps> & {
    phone: Phone;
    onRemove?: (phone: Phone) => void;
    onSetAsPrimary?: (phone: Phone) => void;
}
export const PhoneControl = (props: PhoneControlProps) => {

    const { phone, onRemove, size, onSetAsPrimary } = props;

    //Hooks
    const utils = useUtilities();

    //Styles
    const commonStyles = useCommonStyles();
    const styles = useStyles();

    //UI Events
    const onClickPrimary = (e: any) => {
        e.stopPropagation();
        !!onSetAsPrimary && onSetAsPrimary(phone);
    }

    return (
        <>
            <ListItem className={styles.item}>
                <Row gap='small'>
                    <Column vAlign='middle' width='auto'>
                        {!!onSetAsPrimary && (
                            <Tooltip content={phone.primary ? 'Primary phone' : 'Make primary phone'} relationship='description'>
                                <Button
                                    className={commonStyles.button.root}
                                    size='small'
                                    icon={phone.primary ? <StarFilled /> : < StarRegular />}
                                    appearance='transparent'
                                    shape='circular'
                                    onClick={!phone.primary ? onClickPrimary : undefined}
                                    data-testid={`phone-control-primary-button-${phone.number}`}
                                />
                            </Tooltip>
                        )}
                    </Column>
                    <Column vAlign='middle'>
                        <Text size={size}><Text weight='semibold'>{phone.type ? `${utils.toPascalCase(phone.type as string)}: ` : ''}</Text>{phone.number}</Text>
                    </Column>
                    <Column vAlign='middle' width='auto'>
                        {!!onRemove &&
                            <Button
                                className={mergeClasses(commonStyles.button.root, 'hidden')}
                                appearance='transparent'
                                icon={<Dismiss16Regular />}
                                onClick={() => onRemove(phone)}
                                data-testid={`phone-control-remove-button-${phone.number}`}
                            />}
                    </Column>
                </Row>
            </ListItem>
        </>
    );
}